<template>
  <div class="creator-panel" :class="{ embedded: embedded }">
    <!-- 首页视图 -->
    <div v-if="activeView === 'home'">
      <!-- 数据概览 -->
      <div class="stats-grid">
        <div class="stat-card">
          <div class="stat-icon orange">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
          </div>
          <div class="stat-value">{{ stats.followers }}</div>
          <div class="stat-label">粉丝数</div>
        </div>
        <div class="stat-card">
          <div class="stat-icon blue">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="6" width="18" height="12" rx="3"/><circle cx="11" cy="12" r="3" fill="currentColor"/><path d="M22 9v6"/></svg>
          </div>
          <div class="stat-value">{{ stats.views }}</div>
          <div class="stat-label">总观看数</div>
        </div>
        <div class="stat-card">
          <div class="stat-icon green">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>
          </div>
          <div class="stat-value">{{ stats.videos }}</div>
          <div class="stat-label">作品数</div>
        </div>
        <div class="stat-card">
          <div class="stat-icon orange">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
          </div>
          <div class="stat-value">¥{{ stats.income }}</div>
          <div class="stat-label">本月收入</div>
        </div>
      </div>

      <!-- 快捷操作 -->
      <div class="section">
        <div class="section-title">
          <span class="st-bar"></span>
          快捷操作
        </div>
        <div class="quick-grid">
          <div class="quick-item" @click="goLive">
            <div class="quick-icon live">
              <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="6" width="18" height="12" rx="3"/><circle cx="11" cy="12" r="3" fill="currentColor"/><path d="M22 9v6"/></svg>
            </div>
            <span>开始直播</span>
          </div>
          <div class="quick-item" @click="uploadVideo">
            <div class="quick-icon upload">
              <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
            </div>
            <span>上传视频</span>
          </div>
          <div class="quick-item" @click="manageVideos">
            <div class="quick-icon manage">
              <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>
            </div>
            <span>作品管理</span>
          </div>
          <div class="quick-item" @click="viewData">
            <div class="quick-icon data">
              <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>
            </div>
            <span>数据分析</span>
          </div>
        </div>
      </div>

      <!-- 最近作品 -->
      <div class="section">
        <div class="section-title">
          <span class="st-bar"></span>
          最近作品
          <span class="st-more" @click="manageVideos">查看全部 ></span>
        </div>
        <div v-if="recentVideos.length === 0" class="empty-box">
          <img :src="logo" alt="">
          <p>暂无作品，快去上传第一条视频吧</p>
        </div>
        <div v-else class="video-grid">
          <div class="video-card" v-for="v in recentVideos" :key="v.id">
            <div class="vc-thumb">
              <img :src="getFullImageUrl(v.cover)" @error="handleImgError" alt="">
              <div class="vc-duration">{{ v.duration || '00:00' }}</div>
            </div>
            <div class="vc-info">
              <div class="vc-title">{{ v.title }}</div>
              <div class="vc-meta">
                <span>{{ formatViews(v.views) }}观看</span>
                <span>{{ formatTime(v.createtime) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 收入趋势 -->
      <div class="section">
        <div class="section-title">
          <span class="st-bar"></span>
          近7日收入趋势
        </div>
        <div class="income-chart">
          <div class="chart-bar" v-for="(d, i) in incomeData" :key="i">
            <div class="bar-fill" :style="{ height: (d.value / maxIncome * 100) + '%' }"></div>
            <div class="bar-value">¥{{ d.value }}</div>
            <div class="bar-label">{{ d.day }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 作品管理视图 -->
    <div v-else-if="activeView === 'manage'">
      <div class="section-title">
        <span class="st-bar"></span>
        作品管理
        <span class="st-more" @click="backToHome">返回首页 ></span>
      </div>
      <div v-if="allVideos.length === 0" class="empty-box">
        <img :src="logo" alt="">
        <p>暂无作品，快去上传第一条视频吧</p>
      </div>
      <div v-else class="data-table-wrap">
        <table class="data-table">
          <thead>
            <tr>
              <th>封面</th>
              <th>标题</th>
              <th>播放量</th>
              <th>创建时间</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="v in allVideos" :key="v.id">
              <td><img :src="getFullImageUrl(v.cover)" @error="handleImgError" class="row-cover" alt=""></td>
              <td class="td-title">{{ v.title }}</td>
              <td>{{ formatViews(v.views) }}</td>
              <td>{{ formatTime(v.createtime) }}</td>
              <td><button class="delete-btn" @click="handleDeleteVideo(v.id)">删除</button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 数据分析视图 -->
    <div v-else-if="activeView === 'data'">
      <div class="section-title">
        <span class="st-bar"></span>
        数据分析
        <span class="st-more" @click="backToHome">返回首页 ></span>
      </div>
      <div class="analysis-cards">
        <div class="analysis-card">
          <div class="analysis-label">总播放量</div>
          <div class="analysis-value">{{ analysisData.totalViews || 0 }}</div>
        </div>
        <div class="analysis-card">
          <div class="analysis-label">总粉丝数</div>
          <div class="analysis-value">{{ analysisData.totalFans || 0 }}</div>
        </div>
        <div class="analysis-card">
          <div class="analysis-label">总点赞数</div>
          <div class="analysis-value">{{ analysisData.totalLikes || 0 }}</div>
        </div>
        <div class="analysis-card">
          <div class="analysis-label">本月收入</div>
          <div class="analysis-value">¥{{ analysisData.monthlyIncome || '0.00' }}</div>
        </div>
      </div>
      <div class="section-title" style="margin-top: 24px;">
        <span class="st-bar"></span>
        近7日趋势
      </div>
      <div class="income-chart">
        <div class="chart-bar" v-for="(d, i) in incomeData" :key="i">
          <div class="bar-fill" :style="{ height: (d.value / maxIncome * 100) + '%' }"></div>
          <div class="bar-value">¥{{ d.value }}</div>
          <div class="bar-label">{{ d.day }}</div>
        </div>
      </div>
    </div>

    <!-- 上传弹窗 -->
    <div v-if="showUploadModal" class="modal-overlay" @click="showUploadModal = false">
      <div class="modal-content" @click.stop>
        <h3 class="modal-title">上传视频</h3>
        <div class="form-row">
          <label>标题</label>
          <input type="text" v-model="uploadForm.title" placeholder="请输入视频标题" maxlength="50">
        </div>
        <div class="form-row">
          <label>视频URL</label>
          <input type="text" v-model="uploadForm.url" placeholder="请输入视频URL">
        </div>
        <div class="form-row">
          <label>封面URL</label>
          <input type="text" v-model="uploadForm.cover" placeholder="请输入封面URL">
        </div>
        <div class="form-row">
          <label>时长</label>
          <input type="text" v-model="uploadForm.duration" placeholder="如 00:30" maxlength="8">
        </div>
        <div class="form-row">
          <label>描述</label>
          <textarea v-model="uploadForm.description" placeholder="请输入视频描述" rows="3" maxlength="200"></textarea>
        </div>
        <div class="modal-actions">
          <button class="cancel-btn" @click="showUploadModal = false">取消</button>
          <button class="confirm-btn" @click="handleUpload">确认上传</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { getUserInfo } from '../api/user';
import { BASE_URL } from '../api/config';
import { getCreatorStats, getMyVideos, uploadVideo as apiUploadVideo, deleteVideo, getDataAnalysis } from '../api/creator';

const logo = require('../assets/logo.png');

export default {
  name: 'CreatorPanel',
  props: {
    embedded: { type: Boolean, default: false }
  },
  setup() {
    const router = useRouter();
    const recentVideos = ref([]);
    const stats = ref({ followers: 0, views: 0, videos: 0, income: '0.00' });

    const activeView = ref('home');
    const showUploadModal = ref(false);
    const uploadForm = ref({ title: '', url: '', cover: '', duration: '', description: '' });
    const allVideos = ref([]);
    const analysisData = ref({});

    const incomeData = ref([
      { day: '周一', value: 0 },
      { day: '周二', value: 0 },
      { day: '周三', value: 0 },
      { day: '周四', value: 0 },
      { day: '周五', value: 0 },
      { day: '周六', value: 0 },
      { day: '周日', value: 0 }
    ]);

    const maxIncome = computed(() => Math.max(...incomeData.value.map(d => d.value), 1));

    const getFullImageUrl = (url) => {
      if (!url) return '';
      if (url.startsWith('http') || url.startsWith('data:')) return url;
      return `${BASE_URL}${url}`;
    };

    const handleImgError = (e) => { e.target.style.display = 'none'; };

    const formatViews = (views) => {
      if (!views) return '0';
      if (views >= 10000) return (views / 10000).toFixed(1) + '万';
      return views;
    };

    const formatTime = (ts) => {
      if (!ts) return '';
      const num = Number(ts);
      if (isNaN(num)) return ts;
      return new Date(num * 1000).toLocaleDateString('zh-CN', { month: '2-digit', day: '2-digit' });
    };

    const fetchStats = async () => {
      try {
        const res = await getCreatorStats();
        if (res.code === 1) {
          const data = res.data || {};
          stats.value = {
            followers: data.followers || data.fans_count || 0,
            views: data.views || data.total_views || 0,
            videos: data.videos || 0,
            income: data.income || data.monthlyIncome || '0.00'
          };
        }
      } catch (e) {
        // 兜底：使用用户信息
        try {
          const userRes = await getUserInfo(localStorage.getItem('token'));
          if (userRes.data?.code === 1) {
            const info = userRes.data.data?.userinfo || {};
            stats.value = {
              followers: info.fans_count || 0,
              views: info.total_views || 0,
              videos: 0,
              income: '0.00'
            };
          }
        } catch (err) { /* ignore */ }
      }
    };

    const fetchRecentVideos = async () => {
      try {
        const res = await getMyVideos({ page: 1, limit: 6 });
        if (res.code === 1) {
          recentVideos.value = res.data?.list || [];
          if (!stats.value.videos) {
            stats.value.videos = res.data?.total || recentVideos.value.length;
          }
        }
      } catch (e) { /* ignore */ }
    };

    const fetchAllVideos = async () => {
      try {
        const res = await getMyVideos({ page: 1, limit: 100 });
        if (res.code === 1) {
          allVideos.value = res.data?.list || res.data || [];
        }
      } catch (e) { /* ignore */ }
    };

    const fetchAnalysis = async () => {
      try {
        const res = await getDataAnalysis();
        if (res.code === 1) {
          const data = res.data || {};
          analysisData.value = data;
          if (data.incomeTrend && Array.isArray(data.incomeTrend)) {
            incomeData.value = data.incomeTrend;
          }
        }
      } catch (e) { /* ignore */ }
    };

    const handleUpload = async () => {
      const f = uploadForm.value;
      if (!f.title.trim()) { alert('请输入视频标题'); return; }
      if (!f.url.trim()) { alert('请输入视频URL'); return; }
      try {
        const res = await apiUploadVideo({
          title: f.title.trim(),
          url: f.url.trim(),
          cover: f.cover.trim(),
          duration: f.duration.trim(),
          description: f.description.trim()
        });
        if (res.code === 1) {
          alert('上传成功');
          showUploadModal.value = false;
          uploadForm.value = { title: '', url: '', cover: '', duration: '', description: '' };
          await fetchAllVideos();
          await fetchRecentVideos();
          await fetchStats();
        } else {
          alert(res.msg || '上传失败');
        }
      } catch (e) {
        alert(e.message || '上传失败，请重试');
      }
    };

    const handleDeleteVideo = async (id) => {
      if (!confirm('确定删除该作品？删除后不可恢复')) return;
      try {
        const res = await deleteVideo(id);
        if (res.code === 1) {
          alert('删除成功');
          await fetchAllVideos();
          await fetchRecentVideos();
          await fetchStats();
        } else {
          alert(res.msg || '删除失败');
        }
      } catch (e) {
        alert(e.message || '删除失败，请重试');
      }
    };

    const goLive = () => {
      router.push('/broadcast');
    };

    const uploadVideo = () => {
      showUploadModal.value = true;
    };

    const manageVideos = () => {
      activeView.value = 'manage';
      fetchAllVideos();
    };

    const viewData = () => {
      activeView.value = 'data';
      fetchAnalysis();
    };

    const backToHome = () => {
      activeView.value = 'home';
    };

    onMounted(() => {
      fetchStats();
      fetchAnalysis();
      fetchRecentVideos();
    });

    return {
      stats, recentVideos, incomeData, maxIncome,
      activeView, showUploadModal, uploadForm, allVideos, analysisData,
      getFullImageUrl, handleImgError, formatViews, formatTime,
      goLive, uploadVideo, manageVideos, viewData,
      handleUpload, handleDeleteVideo, backToHome, logo
    };
  }
};
</script>

<style scoped>
.creator-panel {
  padding: 20px;
}
.creator-panel.embedded {
  padding: 0;
}

/* 数据概览 */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  margin-bottom: 28px;
}
.stat-card {
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  padding: 18px;
  text-align: center;
  transition: all 0.25s;
}
.stat-card:hover {
  border-color: #ffe4cc;
  box-shadow: 0 4px 16px rgba(255, 150, 0, 0.08);
}
.stat-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 10px;
  color: #fff;
}
.stat-icon.orange { background: linear-gradient(135deg, #ff6a00, #ff9600); }
.stat-icon.blue { background: linear-gradient(135deg, #3b82f6, #60a5fa); }
.stat-icon.green { background: linear-gradient(135deg, #10b981, #34d399); }
.stat-value {
  font-size: 22px;
  font-weight: 800;
  color: #333;
  margin-bottom: 4px;
}
.stat-label {
  font-size: 13px;
  color: #999;
}

/* 分区 */
.section {
  margin-bottom: 28px;
}
.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 700;
  color: #333;
  margin-bottom: 16px;
}
.st-bar {
  width: 4px;
  height: 16px;
  background: #ff9600;
  border-radius: 2px;
}
.st-more {
  margin-left: auto;
  font-size: 13px;
  color: #999;
  font-weight: normal;
  cursor: pointer;
}
.st-more:hover {
  color: #ff6a00;
}

/* 快捷操作 */
.quick-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
}
.quick-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 20px;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.25s;
}
.quick-item:hover {
  border-color: #ffe4cc;
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(255, 150, 0, 0.1);
}
.quick-icon {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}
.quick-icon.live { background: linear-gradient(135deg, #ef4444, #f87171); }
.quick-icon.upload { background: linear-gradient(135deg, #ff6a00, #ff9600); }
.quick-icon.manage { background: linear-gradient(135deg, #10b981, #34d399); }
.quick-icon.data { background: linear-gradient(135deg, #3b82f6, #60a5fa); }
.quick-item span {
  font-size: 14px;
  color: #666;
  font-weight: 600;
}

/* 作品网格 */
.video-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 14px;
}
.video-card {
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.25s;
}
.video-card:hover {
  border-color: #ffe4cc;
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(255, 150, 0, 0.1);
}
.vc-thumb {
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  background: #f0f0f0;
  overflow: hidden;
}
.vc-thumb img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.vc-duration {
  position: absolute;
  bottom: 6px;
  right: 6px;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 4px;
}
.vc-info {
  padding: 10px 12px;
}
.vc-title {
  font-size: 13px;
  color: #333;
  margin-bottom: 6px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.vc-meta {
  display: flex;
  gap: 10px;
  font-size: 11px;
  color: #999;
}

/* 收入图表 */
.income-chart {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  height: 160px;
  padding: 20px 10px 10px;
  background: #fafafa;
  border-radius: 12px;
}
.chart-bar {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  justify-content: flex-end;
}
.bar-fill {
  width: 60%;
  min-height: 4px;
  background: linear-gradient(180deg, #ff9600, #ff6a00);
  border-radius: 4px 4px 0 0;
  transition: height 0.3s ease;
}
.bar-value {
  font-size: 11px;
  color: #999;
  margin-top: 4px;
}
.bar-label {
  font-size: 12px;
  color: #666;
  margin-top: 4px;
}

/* 空状态 */
.empty-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px;
  color: #999;
}
.empty-box img {
  width: 60px;
  opacity: 0.4;
  margin-bottom: 12px;
}

/* 数据表 */
.data-table-wrap {
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  overflow: hidden;
}
.data-table {
  width: 100%;
  border-collapse: collapse;
}
.data-table th,
.data-table td {
  padding: 12px 16px;
  text-align: left;
  font-size: 13px;
  color: #666;
  border-bottom: 1px solid #f0f0f0;
}
.data-table th {
  background: #fafafa;
  font-weight: 700;
  color: #333;
  font-size: 13px;
}
.data-table tr:last-child td {
  border-bottom: none;
}
.data-table tr:hover td {
  background: #fff8f0;
}
.row-cover {
  width: 80px;
  height: 48px;
  object-fit: cover;
  border-radius: 6px;
  background: #f0f0f0;
}
.td-title {
  font-weight: 600;
  color: #333;
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.delete-btn {
  padding: 6px 14px;
  border: 1px solid #ef4444;
  background: #fff;
  color: #ef4444;
  border-radius: 14px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
}
.delete-btn:hover {
  background: #ef4444;
  color: #fff;
}

/* 数据分析卡片 */
.analysis-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
}
.analysis-card {
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  padding: 20px;
  text-align: center;
  transition: all 0.25s;
}
.analysis-card:hover {
  border-color: #ffe4cc;
  box-shadow: 0 4px 16px rgba(255, 150, 0, 0.08);
}
.analysis-label {
  font-size: 13px;
  color: #999;
  margin-bottom: 8px;
}
.analysis-value {
  font-size: 24px;
  font-weight: 800;
  color: #ff6a00;
}

/* 弹窗 */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}
.modal-content {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  width: 480px;
  max-width: 90vw;
  max-height: 85vh;
  overflow-y: auto;
}
.modal-title {
  font-size: 17px;
  font-weight: 700;
  color: #333;
  margin: 0 0 16px;
}
.modal-content .form-row {
  margin-bottom: 16px;
}
.modal-content .form-row label {
  display: block;
  font-size: 14px;
  color: #666;
  margin-bottom: 6px;
}
.modal-content .form-row input,
.modal-content .form-row textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  font-size: 14px;
  color: #333;
  outline: none;
  box-sizing: border-box;
  transition: all 0.25s;
}
.modal-content .form-row input:focus,
.modal-content .form-row textarea:focus {
  border-color: #ff9600;
  box-shadow: 0 0 0 3px rgba(255, 150, 0, 0.1);
}
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}
.cancel-btn {
  padding: 8px 20px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: #fff;
  color: #666;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}
.cancel-btn:hover {
  background: #f5f5f5;
}
.confirm-btn {
  padding: 8px 20px;
  border: none;
  border-radius: 6px;
  background: linear-gradient(90deg, #ff6a00, #ff9600);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}
.confirm-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(255, 106, 0, 0.3);
}

@media (max-width: 700px) {
  .stats-grid { grid-template-columns: repeat(2, 1fr); }
  .quick-grid { grid-template-columns: repeat(2, 1fr); }
  .analysis-cards { grid-template-columns: repeat(2, 1fr); }
  .data-table { font-size: 12px; }
  .data-table th, .data-table td { padding: 8px 10px; }
  .row-cover { width: 60px; height: 38px; }
}
</style>
